import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { OutboundLink } from "gatsby-plugin-google-gtag";

import Layout from "../components/layout";
import SEO from "../components/seo";

import "../styles/styles.css";

const ScholarlyWorkPage = () => {
  const data = useStaticQuery(graphql`
    query scholarlyQuery {
      allAirtable(
        filter: {
          table: { eq: "Resources" }
          data: { ResourceCategoryTitle: { eq: "Scholarly Work" } }
        }
      ) {
        nodes {
          data {
            ResourceTitle
            ResourceCategoryTitle
            ResourceURL
            ResourceDescription {
              childMdx {
                body
              }
            }
          }
        }
      }
    }
  `);

  const resources = data.allAirtable.nodes;

  return (
    <Layout>
      <SEO title="Scholarly Work" />
      <div className="page-container">
        <h1>Scholarly Work</h1>
        <div className="resource-container">
          <section>
            <div className="column">
              {resources.map((resource, index) => {
                if (index >= resources.length / 2) return null;
                return (
                  <div key={`press-left-${index}`}>
                    <h3>
                      <OutboundLink href={resource.data.ResourceURL}>
                        {resource.data.ResourceTitle}
                      </OutboundLink>
                    </h3>
                    {resource.data.ResourceDescription?.childMdx?.body && (
                      <MDXRenderer
                        components={{
                          p: (props) => <h5 {...props} />,
                        }}
                      >
                        {resource.data.ResourceDescription.childMdx.body}
                      </MDXRenderer>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="column">
              {resources.map((resource, index) => {
                if (index < resources.length / 2) return null;
                return (
                  <div key={`press-right-${index}`}>
                    <h3>
                      <OutboundLink href={resource.data.ResourceURL}>
                        {resource.data.ResourceTitle}
                      </OutboundLink>
                    </h3>
                    {resource.data.ResourceDescription?.childMdx?.body && (
                      <MDXRenderer
                        components={{
                          p: (props) => <h5 {...props} />,
                        }}
                      >
                        {resource.data.ResourceDescription.childMdx.body}
                      </MDXRenderer>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default ScholarlyWorkPage;